export default {"src":"/_next/static/media/wireless.12565b65.svg","height":37,"width":52,"blurWidth":0,"blurHeight":0};